import { Zone } from "@apis/index";
import { deletesvg, edit } from "@assets/icons";
import Column from "@components/column";
import Table from "@components/table";
import Typography from "@components/typography";
import FieldWrapper from "@components/wrapper/field-wrapper";
import React from "react";
import Fields from "@components/fields";
import { Formik } from "formik";
import { toast } from "react-toastify";

interface SurgeListProps {
  data: any[];
  onRefresh: () => void;
  onEdit: (surge: any) => void;
  hasActiveSurge: boolean;
}

const SurgeList: React.FC<SurgeListProps> = ({
  data,
  onRefresh,
  onEdit,
  hasActiveSurge,
}) => {
  const handleStatusToggle = async (surge: any) => {
    try {
      await Zone.patchSurgePrice({
        id: surge.id,
        data: { status: !surge.status },
      });
      onRefresh();
    } catch (error: any) {
      console.error("Error toggling status:", error);
      if (error.message.includes("already active")) {
        toast.error(error.message);
      }
    }
  };

  const handleDelete = async (surgeId: number) => {
    if (window.confirm("Are you sure you want to delete this surge price?")) {
      try {
        await Zone.removeSurgePrice({ id: surgeId });
        onRefresh();
      } catch (error) {
        console.error("Error deleting surge price:", error);
      }
    }
  };

  const columns: any = [
    { title: "SN", key: "sn", render: (_, i) => i + 1 },
    { title: "Title", key: "title" },
    { title: "Vehicle Type", key: "vehicleType" },
    { title: "Surge Type", key: "surgeType" },
    { title: "Amount", key: "surgecharge" },
    {
      title: "Date",
      render: (row) => (
        <span style={{ fontSize: "12px" }}>
          {new Date(row.startDate).toLocaleDateString()} -{" "}
          {new Date(row.endDate).toLocaleDateString()}
        </span>
      ),
    },
    {
      title: "Time",
      render: (row) => (
        <span style={{ fontSize: "12px" }}>
          {row.startTime} - {row.endTime}
        </span>
      ),
    },
    {
      title: "Status",
      render: (row) => (
        <Formik
          key={row.id} // Ensure fresh state on refresh
          initialValues={{ [`status-${row.id}`]: row.status }}
          enableReinitialize
          onSubmit={() => {}}
        >
          <Fields.Switch
            name={`status-${row.id}`}
            disabled={hasActiveSurge && !row.status}
            onChange={() => handleStatusToggle(row)}
          />
        </Formik>
      ),
    },
  ];

  return (
    <FieldWrapper>
      <Column>
        <Typography styleText="font-weight:600;font-size:18px">
          Surge Price Configurations
        </Typography>
        <Typography styleText="font-size:12px;color:gray;margin-top:4px">
          Note: Admin must deactivate the current active surge before activating
          a new one.
        </Typography>
        <br />
        <Table
          hasSearchbar={false}
          columns={columns}
          data={data}
          actions={[
            { key: "edit", icon: edit, onClick: (row) => onEdit(row) },
            {
              key: "remove",
              icon: deletesvg,
              onClick: (row) => handleDelete(row.id),
            },
          ]}
        />
      </Column>
    </FieldWrapper>
  );
};

export default SurgeList;
